import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row gap-sm" }
const _hoisted_2 = { class: "row items-center gap-sm" }
const _hoisted_3 = { class: "text-subtitle2" }
const _hoisted_4 = { class: "text-h5" }
const _hoisted_5 = { class: "row items-center gap-sm" }
const _hoisted_6 = { class: "text-h5" }
const _hoisted_7 = { class: "text-subtitle2" }

import { getTranslatedEntityForPage } from "src/util/functions/entity"
import { EntityPages } from "src/util/types/dataModels/entityDefinition"
import { computed, PropType } from "vue"
import { useI18n } from "vue-i18n"
import SfxTooltip from "../tooltip/SfxTooltip.vue"

//region Props and Emits

const TOGGLE_SIZE = "16px"
const TOGGLE_PADDING = "5px 11px"


export default /*#__PURE__*/_defineComponent({
  __name: 'SfxTableToggle',
  props: {
  modelValue: {
    type: Boolean,
    required: true,
  },

  toDoCount: {
    type: Number,
    required: true,
  },

  performedCount: {
    type: Number,
    required: true,
  },

  entity: {
    type: String as PropType<EntityPages>,
    required: true,
  },

  disable: {
    type: Boolean,
    default: false,
  },
},
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {

const props = __props

const emit = __emit

//endregion

//region Variables

const { t } = useI18n()

const isDisplayingToDoEntities = computed({
  get() {
    return props.modelValue
  },

  set(value) {
    return emit("update:modelValue", value)
  },
})

const toggleToDoClasses = computed(
  () => `sfx-table-toggle__to-do-${isDisplayingToDoEntities.value ? "on" : "off"}`
)

const togglePerformedClasses = computed(
  () => `sfx-table-toggle__performed-${!isDisplayingToDoEntities.value ? "on" : "off"}`
)

const translatedEntity = computed(() => getTranslatedEntityForPage(props.entity, true))

const toggleToDoLabel = computed(() =>
  t("sfxTable.toggle_to_do", { entity: translatedEntity.value })
)
const togglePerformedLabel = t("sfxTable.toggle_performed")

//endregion

//region Functions

function handleToDoClick() {
  isDisplayingToDoEntities.value = true
}

function handlePerformedClick() {
  isDisplayingToDoEntities.value = false
}

//endregion

return (_ctx: any,_cache: any) => {
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_separator = _resolveComponent("q-separator")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, _toDisplayString(toggleToDoLabel.value), 1),
      _createVNode(_component_q_btn, {
        disable: props.disable,
        size: TOGGLE_SIZE,
        padding: TOGGLE_PADDING,
        onClick: handleToDoClick,
        class: _normalizeClass(["sfx-table-toggle sfx-table-toggle__to-do", toggleToDoClasses.value])
      }, {
        default: _withCtx(() => [
          _createElementVNode("span", _hoisted_4, _toDisplayString(props.toDoCount), 1)
        ]),
        _: 1
      }, 8, ["disable", "class"]),
      _createVNode(SfxTooltip, {
        data: { text: _unref(t)('sfxTooltip.todo_on_work_order'), isHtml: true }
      }, null, 8, ["data"])
    ]),
    _createVNode(_component_q_separator, {
      vertical: "",
      inset: "",
      class: "rounded-borders"
    }),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_q_btn, {
        disable: props.disable,
        size: TOGGLE_SIZE,
        padding: TOGGLE_PADDING,
        onClick: handlePerformedClick,
        class: _normalizeClass(["sfx-table-toggle sfx-table-toggle__performed", togglePerformedClasses.value])
      }, {
        default: _withCtx(() => [
          _createElementVNode("span", _hoisted_6, _toDisplayString(props.performedCount), 1)
        ]),
        _: 1
      }, 8, ["disable", "class"]),
      _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(togglePerformedLabel)), 1),
      _createVNode(SfxTooltip, {
        data: { text: _unref(t)('sfxTooltip.performed_on_work_order'), isHtml: true }
      }, null, 8, ["data"])
    ])
  ]))
}
}

})